export default ({ data }) => {
  return {
    title: data.title,
    text: data.text,
  };
};
